// import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/main.scss';
import registerServiceWorker from "@/registerServiceWorker.ts";
import "@webcore/utilities/Extensions.ts";
import { appConfig } from "@webcore/config/appConfig.ts";
import Log from "@webcore/services/log/log.ts";

Log.info(`app index boot - version=${appConfig.buildDate} [${appConfig.buildHash}]`);

registerServiceWorker();

// Get the root element
const rootElement = document.getElementById('root');

// Ensure root element exists
if (!rootElement) {
  throw new Error('Root element not found');
}

// Create and render root
const root = ReactDOM.createRoot(rootElement);

root.render(<App />);
